module.exports = __webpack_public_path__ + "img/appBar.44f759b5.png";